export default __webpack_public_path__ + "static/media/oolancer.4dc3267b.png";